import React from "react";
import { Button } from "../components/styled/button";
import { Box } from "../components/styled/box";
import styled from "styled-components";
import Countdown from "../components/Countdown";
import { postOtpConsent } from "../redux/subscription/subscription.utils";
import { useLocation } from "react-router-dom";
import Modal from "../components/Modal";

export default function OtpVerification({ setIsModalOpen }) {
  const [otpCode, setOtpCode] = React.useState("");
  const [errorModal, setErrorModal] = React.useState(false);
  const [errorModalContent, setErrorModalContent] = React.useState("");
  const {
    state: { partnerId, transactionId },
  } = useLocation();
  const portal = localStorage.getItem("platform");

  const setMsgVisible = () => {
    console.log("calling here");
    setIsModalOpen(true);
  };

  // console.log("OtpCode", otpCode);

  const handleOTPVerify = async () => {
    if (
      otpCode.length &&
      (otpCode.length === 4 || otpCode.length === 5 || otpCode.length === 6)
    ) {
      const response = await postOtpConsent(partnerId, transactionId, otpCode);
      console.log("Response data", response);
      if (response.status === 200) {
        response.data && window.location.replace(response.data?.message);
      } else {
        setErrorModal(true);
        setErrorModalContent(response?.data?.message);
      }
    }
  };

  const closeModal = () => {
    setErrorModal(false);
    setErrorModalContent("");
  };

  const handleOTPClose = () => {
    setIsModalOpen(false);
    localStorage.clear();
    window.location.replace(`https://${portal}`);
  };

  return (
    <OTPWrapper>
      <div>
        <Modal isOpen={errorModal} onClose={closeModal}>
          <p>{errorModalContent}</p>
        </Modal>
      </div>
      <Box className="otpBox">
        <Header>Verification</Header>
        <SubHeader>You will get a OTP via SMS</SubHeader>
        <Countdown timeLimit={240} setMsgVisible={setMsgVisible} />
        <InputPassword
          type="text"
          placeholder="Enter OTP"
          onChange={(e) => {
            e.persist();
            setOtpCode(e.target.value);
          }}
        />
        {otpCode.length && otpCode.length < 4 ? (
          <p>Your Otp is not valid</p>
        ) : (
          ""
        )}
        <div
          style={{
            display: "flex",
            columnGap: "1rem",
            justifyContent: "center",
          }}
        >
          <Button
            variant="secondary"
            //   width="50%"
            style={{
              marginTop: "1.5em",
              height: 42,
              fontWeight: 600,
              fontSize: 14,
              cursor: "pointer",
            }}
            onClick={handleOTPClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            //   width="50%"
            style={{
              marginTop: "1.5em",
              height: 42,
              fontWeight: 600,
              fontSize: 14,
              cursor: "pointer",
            }}
            onClick={handleOTPVerify}
          >
            Verify
          </Button>
        </div>
      </Box>
    </OTPWrapper>
  );
}

const OTPWrapper = styled.div`
  font-family: "Noto Sans";
  width: 100%;
  height: 100vh;
  display: grid;
  justify-content: center;
  align-items: center;
  .otpBox {
    background-color: rgba(36, 38, 45, 0.57);
    box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 6px;
    max-width: 25rem;
    width: 25rem;
    padding: 3rem 2rem;
    text-align: center;
  }
`;

const Header = styled.h1`
  margin-bottom: 0.3rem;
`;

const SubHeader = styled.p`
  margin-bottom: 2rem;
`;

const InputPassword = styled.input`
  height: 3rem;
  padding: 0.5em;
  margin: 0.5em 0;
  width: 100%;
  border-radius: 6px;
  text-align: center;
  font-size: 1.5em;
  letter-spacing: 0.3em;
  &::placeholder {
    font-size: 1rem;
    letter-spacing: normal;
  }
  &:focus {
    outline: none;
  }
`;
